import { HttpResponse } from 'shell/models/http-response';
import { Municipality } from 'shell/models/municipality';
import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { MunicipalityForm } from '../components/municipality/form';

export const transformResponseMunicipalityEditItalian = (
  response: AxiosResponse<HttpResponse<Municipality>>
): MunicipalityForm => {
  const municipalityPayload = response.data?.payload;

  return {
    code: municipalityPayload.key?.codice,
    name: municipalityPayload.nome,
    province: municipalityPayload.provincia?.trim() || '',
    capital: municipalityPayload.capoluogo?.trim() === 'S' ? true : false,
    region: municipalityPayload.regione?.toString() || '',
    cap: municipalityPayload.cap?.toString() || '',
    court: municipalityPayload.tribunale?.toString() || '',
    fiscalCode: municipalityPayload.codFiscale,
    istatCode: municipalityPayload.codIstat,
    institutionDate: municipalityPayload.dataIstituz
      ? DateTime.fromISO(municipalityPayload.dataIstituz)
      : null,
  };
};

export const transformRequestMunicipalityItalian = (
  formValues: MunicipalityForm | undefined
): Municipality => {
  return {
    dataIstituz: formValues?.institutionDate?.toFormat('yyyyMMdd') || undefined,
    tribunale: formValues?.court ? Number.parseInt(formValues.court, 10) : undefined,
    cap: formValues?.cap || undefined,
    codIstat: formValues?.istatCode || undefined,
    regione: formValues?.region || undefined,
    provincia: formValues?.province || undefined,
    codFiscale: formValues?.fiscalCode || undefined,
    capoluogo: formValues?.capital ? 'S' : 'N',
    nome: formValues?.name || undefined,
    key: formValues?.code
      ? {
          codice: formValues?.code,
        }
      : undefined,
  };
};

export const transformResponseMunicipalityEditForeign = (
  response: AxiosResponse<HttpResponse<Municipality>>
): MunicipalityForm => {
  const municipalityPayload = response.data?.payload;

  return {
    code: municipalityPayload.key?.codice,
    name: municipalityPayload.nome,
    fiscalCode: municipalityPayload.statoEsteroVO?.belfiore || '',
    istatCode: municipalityPayload.codIstat,
    foreignState: municipalityPayload.provincia?.trim(),
    site: municipalityPayload.comuneTerritorioConsolato?.codiceConsolato || '',
    territory: municipalityPayload.codTerritorio?.toString() || '',
    institutionDate: municipalityPayload.dataIstituz
      ? DateTime.fromISO(municipalityPayload.dataIstituz)
      : DateTime.now(),
  };
};

export const transformRequestMunicipalityForeign = (
  formValues: MunicipalityForm | undefined
): Municipality => {
  return {
    codIstat: formValues?.istatCode || undefined,
    codFiscale: formValues?.fiscalCode?.trim() || undefined,
    dataIstituz: formValues?.institutionDate?.toFormat('yyyyMMdd') || undefined,
    nome: formValues?.name || undefined,
    provincia: formValues?.foreignState || undefined,
    regione: formValues?.region || undefined,
    cap: formValues?.cap || undefined,
    comuneTerritorioConsolato:
      formValues?.territory || formValues?.site
        ? {
            codiceTerritorio: formValues?.territory,
            codiceConsolato: formValues?.site,
          }
        : undefined,
  };
};
